exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-54b5b89d] .md-table-head-label {\n  color: #4caf50 !important;\n}\n[data-v-54b5b89d] .md-table-head {\n  cursor: default;\n}\n.table-hover[data-v-54b5b89d] {\n  cursor: pointer;\n}\n.label-total[data-v-54b5b89d] {\n  float: right;\n  font-size: 14px;\n  font-weight: 500;\n}\n.label-total span[data-v-54b5b89d] {\n    display: block;\n}\n", ""]);

// exports
